import React, { Component } from 'react';
import { Input, Select, Radio, Checkbox, Button, Form, Spin, message, Divider, Row, Col, notification } from 'antd';
import 'antd/dist/reset.css';
import dayjs from 'dayjs';
import { AutoCompleteItem, DatePickerItem, dineroDisabledMask, ErrorItem, FormItem, InputNumberItem, withRouter } from '../../Components/Items'
import axios from 'axios';
import { FacebookOutlined, InstagramOutlined } from '@ant-design/icons';

const { Option } = Select;

class RegistroCarrera extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    objetoCarreras: null,
    todasCarreras: [],
    optionEquipos: [],
    todasEquipos: []
  };

  componentDidMount() {
    this.setState({ loading: true })
    axios
      .post(
        "registroCarrera/datosParaRegistro",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            todasCarreras: res.data.carreras,
            objetoCarreras: res.data.carreras.map(valueCarrera => (
              <Option value={valueCarrera._id} key={valueCarrera._id}>
                {valueCarrera.nombre + ' - ' + valueCarrera.distancia + ' km ' + dineroDisabledMask(valueCarrera.precio)}
              </Option>
            )),
            todasEquipos: res.data.equipos,
            optionEquipos: res.data.equipos.map(valueEquipo => {
              return {
                label: valueEquipo.nombre,
                value: valueEquipo.nombre
              }
            }),
          })
        } else {
          message.error("Error no se encontro informacion para el registro");
        }
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!values.terminos) return message.info('Porfavor acepte los terminos')
    if (!values.terminos2) return message.info('Porfavor acepte los terminos')
    if (values?.telefono?.toString()?.length !== 10) return message.info('El numero de telefono debe ser de 10 digitos')
    axios
      .post(
        "registroCarrera/nuevoRegistroCarrera",
        {
          ...values,
          empresaId: this.props.empresaId,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          notification.success({
            message: "Referencia: " + res.data.folio,
            description: "Registro exitoso con referencia: " + res.data.folio
          })
          this.props.navigate('/registroPago', { state: { id: res.data.registroId } });
        } else if (res.data.success === 1) {
          message.error("No se pudo registrar");
        } else {
          message.error("Sucedió un error y no se pudo registrar");
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  };

  render() {
    return (
      <div className='registro-carrera-backgorund'>
        <div className="registro-carrera-container">
          <h1 className="registro-carrera-title">Registro #TodosSomosDiferentes</h1>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              layout="vertical"
              name="registroCarrera"
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed.bind(this)}
              className="registro-carrera-form"
            >
              <FormItem
                label="Nombre Completo"
                required
                name="nombre"
              >
                <Input
                  placeholder="Nombre completo"
                />
              </FormItem>

              <FormItem
                label="Fecha de Nacimiento"
                required
                name="fechaNacimiento"
              >
                <DatePickerItem
                  disabledDate={(current) => {
                    return current && (current < dayjs('1900-01-01') || current > dayjs());
                  }}
                />
              </FormItem>

              <FormItem
                label="Correo Electrónico"
                required
                email={true}
                name="correo"
              >
                <Input
                  placeholder="correo@ejemplo.com"
                />
              </FormItem>


              <FormItem
                label="Teléfono"
                required
                name="telefono"
              >
                <InputNumberItem placeholder="Teléfono" celular={true} />
              </FormItem>


              <FormItem
                label="Equipo"
                name="equipo"
              >
                <AutoCompleteItem
                  options={this.state.optionEquipos}
                  virtual={false}
                  placeholder="Nombre del equipo"
                  filterOption={(inputValue, option) => option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                />
              </FormItem>

              <FormItem label="Rama" name="rama" required>
                <Radio.Group
                >
                  <Radio value={1}>Varonil</Radio>
                  <Radio value={2}>Femenil</Radio>
                </Radio.Group>
              </FormItem>

              <FormItem
                label="Carrera"
                required
                name="carreraId"
              >
                <Select
                  placeholder="Selecciona una carrera"
                >
                  {this.state.objetoCarreras}
                </Select>
              </FormItem>

              <FormItem
                name="terminos"
                valuePropName="checked"
                required
              >
                <Checkbox>
                  De los accidentes que llegaran a sufrir los participantes, el comité organizador no se hace responsable por considerarse riesgos deportivos. Si se llegara a capturar un dato con información incorrecta el comité administrador adquiere absoluta libertad de revocar la premiación y reasignarlo al siguiente participante de ser necesario.
                </Checkbox>
              </FormItem>

              <FormItem
                name="terminos2"
                valuePropName="checked"
                required
              >
                <Checkbox>
                  Acepto los
                  <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer"> Términos y Condiciones</a>,
                  <a href="/politicaPrivacidad" target="_blank" rel="noopener noreferrer"> Aviso de Privacidad</a>, y
                  <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer"> Política de Cancelación y Devolución</a>.
                </Checkbox>
              </FormItem>

              <FormItem>
                <Button type="primary" htmlType="submit" className="registro-carrera-button">
                  Registrar
                </Button>
              </FormItem>

              <div className="registro-carrera-redes">
                <a href="https://www.facebook.com/IntegrameDown" target="_blank" rel="noopener noreferrer">
                  <FacebookOutlined style={{ fontSize: '24px', marginRight: '10px', color: '#3b5998' }} />
                </a>
                <a href="https://www.instagram.com/integramedown" target="_blank" rel="noopener noreferrer">
                  <InstagramOutlined style={{ fontSize: '24px', color: '#e1306c' }} />
                </a>
              </div>

              <Divider style={{ color: 'black', borderColor: 'black' }} />
              <Row>
                <Col span={6}></Col>
                <Col span={12}>
                  <Button onClick={() => this.props.navigate('/registroPago')} className="registro-carrera-button">
                    Pago
                  </Button>
                </Col>
                <Col span={6}></Col>
              </Row>
              <div className="registro-carrera-links">
                <p>
                  Consulta los
                  <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer"> Términos y Condiciones</a>,
                  <a href="/politicaPrivacidad" target="_blank" rel="noopener noreferrer"> Aviso de Privacidad</a>, y
                  <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer"> Política de Cancelación y Devolución</a>.
                </p>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}

export default withRouter(RegistroCarrera);